export enum PersonComponentType {
  Person = 'PERSON',
  Quote = 'QUOTE'
}

export type PersonType = {
  _uid?: string
  image: ImageTypes
  name: string
  role: string
  description?: string
  componentType?: PersonComponentType
}
